import React, { useMemo } from 'react';
import { useRecoilValue } from 'recoil';
import { eyeTestState } from '../../../utils/recoil/eyeTest';
import { EyeTestForm } from './eyeTestForm/eyeTestForm';
import { EyeTestResult } from './eyeTestResult/eyeTestResult';
import { EyeTestStart } from './eyeTestStart/eyeTestStart';
import scrollUp from 'utils/globals/scrollUp';
import GaTriggerEventFactory from 'utils/factories/GaTriggerEventFactory';

export const EyeTest = ({
  startStep,
  formStep,
  resultStep,
  resultNoCorrection,
  gaId,
}) => {
  const eyeTest = useRecoilValue(eyeTestState);
  const { isInit, isCompleted } = eyeTest;
  const isFormActive = !isInit && !isCompleted;
  const testId = useMemo(() => gaId?.text, [gaId]);
  const startTrigger = useMemo(
    () => new GaTriggerEventFactory(testId, 'Start', `${testId}-Start`),
    []
  );
  const resultTrigger = useMemo(
    () => new GaTriggerEventFactory(testId, 'Result', `${testId}-Result`),
    []
  );

  const returnFormCycle = () => {
    if (isInit) {
      // 1st step
      return <EyeTestStart scrollUp={scrollUp} startStep={startStep} />;
    } else if (isFormActive) {
      // 2nd step
      return (
        <EyeTestForm
          scrollUp={scrollUp}
          formStep={formStep}
          triggerEvent={startTrigger}
        />
      );
    } else {
      // 3rd step
      return (
        <EyeTestResult
          scrollUp={scrollUp}
          resultStep={resultStep}
          resultNoCorrection={resultNoCorrection}
          triggerEvent={resultTrigger}
        />
      );
    }
  };
  return <div className='w-full'>{returnFormCycle()}</div>;
};
